import React, { Component } from "react"
import { makeStyles, withStyles } from '@material-ui/core/styles';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import { gethistorylogcorrectdocinfo } from "../../../actions/CorrectiveActions";
import PropTypes from 'prop-types';
import styles from "../../../assets/jss/customStyle"
import $ from "jquery"
import moment from "moment";

class HistoryLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId: 0,
            isMobile: false,
            menu: true,
        }
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId")
        dispatch(gethistorylogcorrectdocinfo(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { isEdit } = this.state;
        let { classes, getprojectid, menuToggle, projectList } = this.props;
        return (
            <>
                <div className="row" >
                    <div className="col-6">
                        <div className="table-responsive" style={{ width: "100%" }}>
                            <table className="dataTable">
                                <thead>
                                    <tr className="">
                                        <th className="border-right" width="40%"><span className="fw-bold" style={{ color: "#000000" }}>Timestamp</span></th>
                                        <th className="border-right" width="30%"><span className="fw-bold" style={{ color: "#000000" }}>Action</span></th>
                                        <th className="" width="30%"><span className="fw-bold" style={{ color: "#000000" }}>Action by</span></th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontFamily: 'Segoe UI' }}>
                                    {this.props.historyLog && this.props.historyLog.map((i) => (
                                        <tr>
                                            <td className="">{moment(i.TimeStamp).format("DD-MM-YYYY HH:MM:SS A")}</td>
                                            <td className="">{i.Action}</td>
                                            <td className="">{i.ActionBy}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        historyLog: state.commonReducer.historyLog || [],
    };
}

HistoryLog.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HistoryLog))
);
